import {
  Box,
  Container,
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderTopWidth: theme.spacing(1),
      borderTopColor: theme.palette.grey['500'],
      width: '100%',
      padding: theme.spacing(2),
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.main,
      '& a': {
        borderBottom: 'none',
      },
      '& path': {
        fill: theme.palette.primary.light,
      },
    },
    link: {
      display: 'block',
      margin: '10px',
      borderBottom: '1px solid transparent',
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontFamily:
        'BundesSans, Verdana, Arial, Helvetica, --apple-system, sans-serif;',
      '&:hover': {
        color: theme.palette.primary.dark,
        borderColor: theme.palette.primary.dark,
      },
    },
  })
);

const Footer: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Container>
        <Box display="flex" justifyContent="center">
          <a
            className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
            href="https://radparken.info/kontakt"
          >
            Kontakt
          </a>
          <a
            className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
            href="https://radparken.info/impressum"
          >
            Impressum
          </a>
          <a
            className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
            href="https://radparken.info/datenschutz"
          >
            Datenschutz
          </a>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
